import { gql } from "@apollo/client"

export const CREATE_LICENSE_POOLS = gql`
  mutation createLicensePools($data: CreateLicensePoolsInput!) {
    licensePools {
      createLicensePools(data: $data) {
        id
      }
    }
  }
`

export const UPDATE_LICENSE_POOLS = gql`
  mutation updateLicensePools($data: UpdateLicensePoolsInput!) {
    licensePools {
      updateLicensePools(data: $data)
    }
  }
`

export const DELETE_LICENSE_POOLS = gql`
  mutation deleteLicensePools($data: DeleteLicensePoolsInput!) {
    licensePools {
      deleteLicensePools(data: $data)
    }
  }
`

// ! NOT USED IN WORKKEYS
// export const IMPORT_LICENSE_POOLS_FROM_CSV = gql`
//   mutation importLicensePoolsFromCSV($data: ImportLicensePoolsFromCSVInput!) {
//     licensePool {
//       importLicensePoolsFromCSV(data: $data) {
//         fileId
//         success
//         message
//         rowResults {
//           rowNumber
//           status
//           districtName
//           schoolName
//           error
//         }
//         summary {
//           total
//           created
//           updated
//           failed
//         }
//       }
//     }
//   }
// `
